import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert } from "@material-ui/lab"
import * as constants from "../constants"

const styles = (theme) => ({
    button: {
        margin: theme.spacing.unit,
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
})

class FireNonIndustrialCov extends Component {
    cookies = new Cookies()

    constructor(props) {
        super(props)

        this.state = {
            fireCovarageState: this.props.fireCovarages,
            selectedCoverage: {
                value: (this.props.fireCovarages && this.props.fireCovarages.firenonindustrial_price_covarage_id) || '',
                label: (this.props.fireCovarages && this.props.fireCovarages.coverage_name) || '',
            },
            visible: true,
            snackstr: "",
            showSnack: false,
            snackMode: "success",
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.fireCovarages !== this.props.fireCovarages) {
            this.setState({
                fireCovarageState: this.props.fireCovarages,
                selectedCoverage: {
                    value: (this.props.fireCovarages && this.props.fireCovarages.firenonindustrial_price_covarage_id) || '',
                    label: (this.props.fireCovarages && this.props.fireCovarages.coverage_name) || '',
                }
            })
        }
    }

    handleClickcloseTasckBar = () => {
        this.setState({ showSnack: false })
    }

    handleCoverageChange = (selectedOption) => {
        const temparray = { ...this.state.fireCovarageState }
        temparray.firenonindustrial_price_covarage_id = selectedOption.value
        this.setState({
            selectedCoverage: selectedOption,
            fireCovarageState: temparray
        })
    }

    handleChangePercent = (event) => {
        const temparray = { ...this.state.fireCovarageState }
        temparray.firenonindustrial_price_covarage_percent = event.target.value
        this.setState({ fireCovarageState: temparray })
    }

    modifyCoverage = () => {
        const { fireCovarageState } = this.state

        const self = this
        const xhttp = new XMLHttpRequest()

        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                const arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({
                        snackstr: arr.desc,
                        showSnack: true,
                        snackMode: "success"
                    })
                } else if (arr.result === "error") {
                    self.setState({
                        snackstr: arr.desc,
                        showSnack: true,
                        snackMode: "error"
                    })
                }
            }
        }

        const fd = new FormData()
        fd.append("command", "modify_price_covarage")
        fd.append("firenonindustrial_price_covarage_id", fireCovarageState.firenonindustrial_price_covarage_id)
        fd.append("firenonindustrial_price_covarage_percent", fireCovarageState.firenonindustrial_price_covarage_percent)

        xhttp.open("POST", `${constants.BASE_URL}/FireNonIndustrial`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    deleteCoverage = () => {
        const { fireCovarageState } = this.state

        const self = this
        const xhttp = new XMLHttpRequest()

        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                const arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({
                        visible: false,
                        snackstr: arr.desc,
                        showSnack: true,
                        snackMode: "success"
                    })
                } else if (arr.result === "error") {
                    self.setState({
                        snackstr: arr.desc,
                        showSnack: true,
                        snackMode: "error"
                    })
                }
            }
        }

        const fd = new FormData()
        fd.append("command", "delete_price_covarage")
        fd.append("firenonindustrial_price_covarage_id", fireCovarageState.firenonindustrial_price_covarage_id)

        xhttp.open("POST", `${constants.BASE_URL}/FireNonIndustrial`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    render() {
        const { classes, optionCoverage } = this.props
        const {
            snackMode,
            snackstr,
            showSnack,
            visible,
            selectedCoverage,
            fireCovarageState
        } = this.state

        if (!visible) {
            return null
        }

        return (
            <Grid container spacing={3}>
                <Snackbar
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    onClose={this.handleClickcloseTasckBar}
                    open={showSnack}
                    autoHideDuration={10000}
                >
                    <Alert severity={snackMode}>{snackstr}</Alert>
                </Snackbar>

                <Grid item xs={5}>
                    <div>
                        <label className="on">پوشش بیمه</label>
                        <Select
                            isSearchable={true}
                            className="adapter-txtsize"
                            placeholder={"پوشش بیمه"}
                            value={selectedCoverage}
                            onChange={this.handleCoverageChange}
                            options={optionCoverage}
                        />
                    </div>
                </Grid>

                <Grid item xs={4}>
                    <FloatingLabelInput
                        placeholder="درصد پوشش"
                        handleInputt={this.handleChangePercent}
                        value={(fireCovarageState && fireCovarageState.firenonindustrial_price_covarage_percent) || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <div style={{ width: "100%", textAlign: "left" }}>
                        <Fab
                            className={classes.small}
                            style={{ background: "#44b700" }}
                            aria-label="edit"
                            onClick={this.modifyCoverage}
                        >
                            <EditIcon />
                        </Fab>

                        <Fab
                            className={classes.small}
                            color="secondary"
                            aria-label="delete"
                            onClick={this.deleteCoverage}
                        >
                            <DeleteIcon />
                        </Fab>
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles)(FireNonIndustrialCov)